const { Application } = Shopware;
import '../core/component/reci-address-checker-rule';

Application.addServiceProviderDecorator('ruleConditionDataProviderService', (ruleConditionService) => {
    ruleConditionService.addCondition('reci_address_checker_check', {
        component: 'reci-address-checker-rule',
        label: 'reci-address-checker.rule.check',
        scopes: ['global']
    });

    return ruleConditionService;
});

